/**
 * Script for Galleria page masonry and filtering by tags
 * 
 * Author: Santeri Ekdahl
 */

// Restrict the script to only Galleria template
if (document.body.classList.contains('page-template-page-galleria')) {

	// Get screen width
	const getColumnCount = () => {
		const width = window.innerWidth;
		if (width < 600) {
			return 1; // Mobile
		} else if (width < 900) {
			return 2; // Tablet
		} else if (width < 1200) {
			return 3; // Small desktop
		} else {
			return 4; // Large desktop
		}
	};

	// TODO: better container naming
	let gallery = document.getElementById('galleria-container');
	let galleryItem = document.querySelectorAll('.galleria-item');
	let masonryColumns = [];
	let allGalleryItems = Array.from(document.querySelectorAll('.galleria-item'));

	const masonryLayout = (containerElements, itemsElements, columns) => {
		// Clean up old column classes
		containerElements.classList.forEach(cls => {
			if (cls.startsWith('columns-')) {
				containerElements.classList.remove(cls);
			}
		});

		containerElements.classList.add('masonry-layout', `columns-${columns}`);

		masonryColumns = []; // Reset global columns array

		for (let i = 1; i <= columns; i++) {
			let column = document.createElement('div');
			column.classList.add('masonry-column', `column-${i}`);
			containerElements.appendChild(column);
			masonryColumns.push(column);
		}

		for (let row = 0; row < Math.ceil(itemsElements.length / columns); row++) {
			for (let itemRow = 0; itemRow < columns; itemRow++) {
				let item = itemsElements[row * columns + itemRow];
				if (!item) continue;
				masonryColumns[itemRow].appendChild(item);
				item.classList.add('masonry-item');
			}
    	}
	};

	masonryLayout(gallery, galleryItem, getColumnCount());

	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			const galleryContainer = document.getElementById('galleria-container');
			const visibleItems = Array.from(document.querySelectorAll('.galleria-item')).filter(item => !item.classList.contains('hidden'));

			// Clear container before rebuilding
			//galleryContainer.innerHTML = '';

			// Rebuild masonry with visible items
			masonryLayout(galleryContainer, visibleItems, getColumnCount());
		}, 200); // debounce time
	});
	const filterButtons = document.querySelectorAll('#filter-buttons button');
	const galleryItems = document.querySelectorAll('.galleria-item');

	filterButtons.forEach(button => {
		button.addEventListener('click', () => {
			const filter = button.getAttribute('data-filter');
			const expectedItemCountForThisFilter = parseInt(button.getAttribute('data-count'), 10);
	
			// Collect matching items directly
			const matchingItems = allGalleryItems.filter(item => {
				const tags = item.getAttribute('data-tags');
				return filter === 'all' || (tags && tags.includes(filter));
			});

			if (filter !== 'all' && matchingItems.length < expectedItemCountForThisFilter) {
				// Make an AJAX request to load all items for this filter
				loadItemsForFilter(filter).then(newItems => {
					// Add new items to global array
					allGalleryItems.push(...newItems);
			
					// Retry filtering
					applyFilter(filter);
				});
			} else {
				// Proceed with filtering as normal
				applyFilter(filter);
			}
	
			// Update active button styling
			filterButtons.forEach(btn => btn.classList.remove('active'));
			button.classList.add('active');
	
			currentPage = 2;
			loadMoreButton.style.display = 'block';
	
			// Optional: if no items match, hide "load more"
			if (matchingItems.length < 1) {
				loadMoreButton.style.display = 'none';
			}
	
			setTimeout(() => {
				const galleryContainer = document.getElementById('galleria-container');
	
				// Remove old items and columns
				allGalleryItems.forEach(item => {
					if (galleryContainer.contains(item)) {
						if (item.parentNode) {
							item.parentNode.removeChild(item);
						}
					}
				});
	
				const existingColumns = galleryContainer.querySelectorAll('.masonry-column');
				existingColumns.forEach(column => column.remove());
	
				// Build new masonry only with matching items
				masonryLayout(galleryContainer, matchingItems, getColumnCount());
			}, 400);
		});
	});


	let currentPage = 2;
	const loadMoreButton = document.getElementById('load-more-button');

	if (loadMoreButton) {
		loadMoreButton.addEventListener('click', function() {
			const activeFilter = document.querySelector('#filter-buttons .active');
			const activeTag = activeFilter ? activeFilter.getAttribute('data-filter') : 'all';

			loadMoreButton.disabled = true;
			loadMoreButton.textContent = 'Loading...';

			const data = new FormData();
			data.append('action', 'load_more_gallery');
			data.append('page', currentPage);
			data.append('tag', activeTag);

			fetch(gallery_ajax_object.ajax_url, {
				method: 'POST',
				body: data
			})
			.then(response => response.text())
			.then(html => {
				if (html.trim() !== '') {
					const tempDiv = document.createElement('div');
					tempDiv.innerHTML = html;
					const newItems = Array.from(tempDiv.children);
			
					newItems.forEach((item, index) => {
						const columnIndex = index % masonryColumns.length;
						masonryColumns[columnIndex].appendChild(item);
					});
			
					newItems.forEach(item => {
						item.classList.add('masonry-item');
						requestAnimationFrame(() => {
							item.classList.add('loaded');
						});
					});

					newItems.forEach(item => {
						allGalleryItems.push(item);
					});
			
					// Auto-filter new items immediately
					const activeFilterButton = document.querySelector('#filter-buttons .active');
					const activeFilter = activeFilterButton ? activeFilterButton.getAttribute('data-filter') : 'all';
			
					newItems.forEach(item => {
						const tags = item.getAttribute('data-tags');
						const isMatch = activeFilter === 'all' || (tags && tags.includes(activeFilter));
			
						if (!isMatch) {
							item.classList.add('hidden');
						}
					});
			
					currentPage++;
					loadMoreButton.disabled = false;
					loadMoreButton.textContent = 'Lataa lisää';

				} else {
					loadMoreButton.style.display = 'none';
				}
			});
		});
	}

	function loadItemsForFilter(filter) {
		return fetch(gallery_ajax_object.ajax_url, {
			method: 'POST',
			body: new URLSearchParams({
				action: 'load_more_gallery',
				page: 1, // Or -1 if you modify PHP to fetch all for the tag
				tag: filter,
			})
		})
		.then(response => response.text())
		.then(html => {
			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = html;
			const newItems = Array.from(tempDiv.children);
	
			newItems.forEach(item => {
				item.classList.add('masonry-item');
				requestAnimationFrame(() => {
					item.classList.add('loaded');
				});
			});
	
			return newItems;
		});
	}
	
	function applyFilter(filter) {
		const matchingItems = allGalleryItems.filter(item => {
			const tags = item.getAttribute('data-tags');
			return filter === 'all' || (tags && tags.includes(filter));
		});
	
		// Optional: hide Load More button if no more needed
		if (filter !== 'all') {
			loadMoreButton.style.display = 'none';
		}
	
		setTimeout(() => {
			const galleryContainer = document.getElementById('galleria-container');
	
			// Remove existing columns
			const existingColumns = galleryContainer.querySelectorAll('.masonry-column');
			existingColumns.forEach(column => column.remove());
	
			// Build masonry with matching items
			masonryLayout(galleryContainer, matchingItems, getColumnCount());
		}, 400);
	}

}